import { IsDefined, IsNumber } from 'class-validator';

export class CreatePasswordTokenCreateDto {
  @IsDefined()
  @IsNumber()
  userId: number;
}
